<template>
    <section>
        <div class="box">
            <b-field label="Add Comment">
                <b-input id="input-comment" type="textarea" v-model="commentData.data"></b-input>
            </b-field>
            <b-field id="reference">
                <b-input v-model="commentData.third_party_code" id="input-comment-reference"></b-input>
            </b-field>
            <div class="is-pulled-left" v-if="isNotUser()">
                <b-field>
                    <b-checkbox v-model="commentData.send_notification" :true-value="true" :false-value="false">Send Notification</b-checkbox>
                </b-field>
            </div>
            <div class="has-text-right">
                <b-button
                    id="btn-add-comment"
                    type="is-success m-r-sm"
                    @click.prevent="createComment"
                    :disabled="loading || commentData.data == null || commentData.data.replace(/^\s+$/,'') == ''"
                >Add Comment</b-button>
                <b-button type="is-default m-r-sm" @click.prevent="goBack()">Cancel</b-button>
            </div>
        </div>
        <br>
        <section v-if="comments.length > 0" style="position:relative">
            <article class="comment media" :data-id="comment.id" :data-reference="comment.attributes.third_party_code" v-for="comment in comments" :key="comment.id">
                <div class="media-content">
                    <div class="content">
                        <div>
                            <strong class="m-l-sm">{{ comment.attributes.created_by }}</strong>
                            <small v-if="comment.attributes.data_type==='system'"
                                class="comment-user m-l-sm has-text-info"
                            >System</small>
                            <small v-else-if="comment.attributes.data_type==='SERVICE-CENTRE'"
                                class="comment-user m-l-sm has-text-info">
                                SERVICE-CENTRE
                            </small>
                            <small v-else
                                class="comment-user m-l-sm has-text-info"
                            >{{ comment.attributes.created_by_email }}</small>
                            <small
                                class="comment-date m-l-sm has-text-danger"
                                :contenteditable="isRole('superadmin') && comment.id"
                                :ref="'comment_'+comment.id"
                                :id="'comment_'+comment.id"
                                @blur="update(comment)"
                                @keyup.enter="update(comment)"
                                @click="updateDate(comment)" v-if="isRole('superadmin')"
                            >{{ comment.attributes.created_at | date}}</small>
                            <small
                                class="comment-date m-l-sm has-text-danger" v-else
                            >{{ comment.attributes.created_at | date}}</small>
                            <br>
                            <em class="comment-text m-l-md" v-if="comment.attributes.data_type==='system'">{{ comment.attributes.data }}</em>
                            <div class="comment-text m-l-md has-new-lines" v-else>{{ comment.attributes.data }}</div>
                        </div>
                    </div>
                </div>
            </article>
            <hr>
            <b-pagination
                v-if="pagination.total >= 1000"
                :total="pagination.total"
                :current.sync="pagination.currentPage"
                :order="pagination.order"
                :size="pagination.size"
                :simple="false"
                :rounded="false"
                :per-page="pagination.perPage"
            ></b-pagination>
            <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
        </section>
    </section>
</template>
<script>
import Vue from "vue";
import moment from 'moment'

export default {
    props: {
        type_id :{
            required:true
        },
        type:{
            required:true
        },
        model:{
            default: null
        }
    },
    data() {
        return {
            loading: false,
            comments: [],
            commentData: {
                data: null,
                data_type: "text",
                scope: null,
                type_id: null,
                type: null,
                third_party_code: null,
                send_notification: true
            },
            pagination: {
                total: 0,
                currentPage: 1,
                perPage: 0,
                order: "default",
                size: "default"
            },
            debounce: null
        };
    },
    watch: {
        "pagination.currentPage"(value) {
            this.loading = true;
            this.getComment(value);
        },
    },
    mounted() {
        this.getComment(1);
        this.commentData.type_id = this.type_id;
        this.commentData.type = this.type;
    },
    methods: {
        getComment(page) {
            this.loading = true;
            let params = `page=${page ? page : 1}&type=${this.type}&type_id=${
                this.type_id
            }`;
            Vue.$logsService
                .getLogs(this.$route.params.id, params)
                .then(response => {
                    this.comments = response.data;
                    if(this.model) {
                        this.comments.push({
                            attributes:{
                                created_at: this.model.created_at,
                                data: 'Ticket created.',
                                data_type: 'system'
                            }
                        })
                    }
                    this.$store.commit("SET_ERRORS", null);
                    this.pagination.total = response.meta.pagination.total;
                    this.pagination.currentPage =
                        response.meta.pagination.current_page;
                    this.pagination.perPage = response.meta.pagination.per_page;
                    this.loading = false;
                });
        },

        async createComment() {
            this.loading = true;
            return await Vue.$logsService.storeLogs(
                this.$route.params.id,
                this.commentData
            ).then(()=>{
                this.loading = false;
                this.commentData.data = null;
                this.commentData.third_party_code = null;
                this.getComment(1);

            }).catch(()=>{
                this.loading = false;
            });
            // this.comments.unshift(comment.data);
            // this.loading = false;
        },
        update(comment) {
            if(this.debounce) {
                clearTimeout(this.debounce)
            }
            var date = document.getElementById('comment_'+comment.id).innerHTML.replace(/<\/?[^>]+(>|$)/g, "")
            var data = {
                created_at: date
            }
            this.debounce = setTimeout(()=>{
                Vue.$logsService.updateLog(comment.id,data).then(()=>{
                    let utc = moment(data.created_at).utc(true)
                    document.getElementById('comment_'+comment.id).innerHTML = moment(utc).local().format('DD-MMM-Y HH:mm').toUpperCase()
                    document.getElementById('comment_'+comment.id).blur()
                    this.$buefy.toast.open({
                        type: 'is-success',
                        message: 'Log updated!'
                    })
                }).catch(()=>{
                    document.getElementById('comment_'+comment.id).blur()
                })
            },500)
        },
        updateDate(comment) {
            if(comment.id && this.isRole('superadmin')){
                var date = comment.attributes.created_at
                this.$nextTick(()=>{
                    document.getElementById('comment_'+comment.id).innerHTML = moment(date).utc().format('DD-MMM-Y HH:mm').toUpperCase()
                })
            }
        }
    }
};
</script>